import { UserManager, WebStorageStateStore } from "oidc-client";
import { ROUTE_PATHS } from "@/router/constants";

const availableScopes = [
  "openid",
  "profile",
  "role",
  "arbitrium_realtime_api",
  "arbitrium_api",
  "activity_logs_api_readonly",
  "aml_screening_api"
];

const config = {
  authority: process.env.VUE_APP_AUTHORITY_URL,
  client_id: "arbitrium.spa@ondato.com",
  redirect_uri: `${window.location.origin}/${ROUTE_PATHS.SIGN_IN_CALLBACK}`,
  silent_redirect_uri: `${window.location.origin}/${ROUTE_PATHS.SILENT_CALLBACK}`,
  post_logout_redirect_uri: `${window.location.origin}/${ROUTE_PATHS.SIGN_OUT_CALLBACK}`,
  response_type: "id_token token",
  scope: availableScopes.join(" "),
  userStore: new WebStorageStateStore({ store: window.localStorage })
};

export const userManager = new UserManager(config);

export function adaptUser({
  id_token,
  profile,
  session_state,
  access_token,
  scope,
  expires_at,
  expires_in,
  expired,
  scopes
}) {
  return {
    idToken: id_token,
    profile,
    sessionState: session_state,
    accessToken: access_token,
    scope,
    expiresAt: expires_at,
    expiresIn: expires_in,
    expired,
    scopes
  };
}
